import React from 'react';
import { Screen } from '../App';
import { useI18n } from '../i18n';

interface Props { navigate: (s: Screen) => void; }

// Site-wide footer. Renders on every page — inside the app frame and beneath the
// full-width marketing homepage. The inner wrapper keeps its content centered on
// wide screens so it lines up with the rest of the page.
export default function Footer({ navigate }: Props) {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  const linkStyle: React.CSSProperties = {
    background: 'none', border: 'none', padding: 0, cursor: 'pointer',
    color: 'var(--text-secondary)', fontSize: 13, fontWeight: 600,
  };
  return (
    <footer style={{ borderTop: '1px solid #ece7df', marginTop: 40, padding: '24px 0' }}>
      <div className="mkt-inner" style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
        <button style={linkStyle} onClick={() => navigate('terms')}>{t('footer.terms')}</button>
        <span style={{ color: '#d8d2c8' }}>·</span>
        <button style={linkStyle} onClick={() => navigate('privacy')}>{t('footer.privacy')}</button>
        <span style={{ color: '#d8d2c8' }}>·</span>
        <button style={linkStyle} onClick={() => navigate('contact')}>{t('footer.contact')}</button>
      </div>
      <p style={{ textAlign: 'center', color: 'var(--text-secondary)', fontSize: 12, marginTop: 12 }}>
        {t('footer.rights', { year })}
      </p>
    </footer>
  );
}
